import React, { useState, useEffect } from "react";
import TableRowComponent from "./../Components/TableRowComponent";
import TableHeadComponent from "./../Components/TableHeadComponent";
import DropDownComponent from "./DropDownComponent";
import axios from "axios";
import "./../assets/sass/_login.scss";
import "./../assets/sass/_review.scss";
import "./../assets/sass/style.css";
import { IoIosAdd } from "react-icons/io";
import Aside from "./aside";
import TopBar from "./topBar";
import { Link } from "react-router-dom";
import { API_Link, validateHeader } from "./../commons/Constants";
import AsidebarNew from "./asidebarNew";
import { DropdownButton, Dropdown, Tabs, Tab } from "react-bootstrap";
import { FaDownload, FaEllipsisV, FaEye } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import HTA from "./FileTemplateComponent/HTA";
import TechBrief from "./FileTemplateComponent/TechBrief";
import IB from "./FileTemplateComponent/IB";
import TechScan from "./FileTemplateComponent/TechScan";
import TR from "./FileTemplateComponent/TR";
import ButtonComponent from "./ButtonComponent";
import Avatar from "./../assets/img/Avatar.png";
import InvitationCard from "./invitationCard";
import { useCallback } from "react";
import gif from "./../assets/img/spin.gif";
import DashboardReview from "./dashboardReview";
function Review() {
  const MD5hash = validateHeader()
  const [review, setReview] = useState("");
  const [filtered_review, setFilteredReview] = useState();
  const [value, setValue] = useState();
  const [showEditModal, setShowEditModal] = useState(false);
  const [reviewTypes, setReviewTypes] = useState([]);
  const [reviewId, setReviewId] = useState();
  const [reviewList, setReviewList] = useState([]);
  const [invitations, setInvitations] = useState([]);


  const [emailSuggestion, setEmailSuggestion] = useState([]);
  const [text, setText] = useState("");
  // edit review
  const [reviewById, setReviewByID] = useState({
    title: "",
    review_type: "",
    tentative_completion_date: "",
    is_followup: "",
  });
 
  const [tabKey, initTabKey] = useState("one");
  const [showEditInvitation, setShowEditInvitation] = useState(false);
  let stage = tabKey === "one" ? "1" : tabKey === "two" ? "2" : tabKey === "three" ? "3" : tabKey === "four" ? "4" : "";
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;
  // console.log("token", token);

  const getReviews = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviews`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        const reviewdata = JSON.stringify(response.data.reviews);
        //onsole.log('reviewdata', reviewdata);
        const valuesArray = JSON.parse(reviewdata);
        // console.log("parsedata", valuesArray);
        setFilteredReview(valuesArray);
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  const getReviewsByID = async (id) => {
    //
    await axios
      .get(`${API_Link}getReviews`, {
        params: {
          id: id,
        },
        headers: {
          "Content-Type": "application/json",
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        // console.log("invitations", response.data);
        setReviewByID({
          title: response.data.reviews[0].title,
          review_type: response.data.reviews[0].review_type.id,
          tentative_completion_date: response.data.reviews[0].tentative_completion_date,
          is_followup: response.data.reviews[0].is_followup === true ? "1" : "0",
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getInvitationById = async (id) => {
    //
    await axios
      .get(`${API_Link}getInvitations`, {
        params: {
          review_id: id,
        },
        headers: {
          "Content-Type": "application/json",
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        // console.log("invitations", response.data);
        setInvitations(response.data.invitations);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getReviewsList = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviewsList`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        const reviewdata = JSON.stringify(response.data.reviews);
        //onsole.log('reviewdata', reviewdata);
        const valuesArray = JSON.parse(reviewdata);
        //console.log('parsedata', valuesArray);
        setReviewList(valuesArray);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  // console.log("reviewtype", reviewById.review_type);
  const getReviewTypes = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviewTypes`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;
        setReviewTypes(resData.data.reviewTypes);

        //   console.log(resData.data.reviewTypes)
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getReviews();
    getReviewTypes();
    getReviewsByID(reviewId);
    getInvitationById(reviewId);
    getReviewsList();
  }, []);
  useState(() => {
    localStorage.setItem("pageId", "2222");
    localStorage.setItem("subPageId", "2223");
  }, []);


  
  const [invitataionId, setInvitationId] = useState();

  console.log("delete id invite", invitataionId);
  // Email Suggesions
  // Debounce to limit number of requests

  const [timer, setTimer] = useState(null);
 

  //


  console.log("emailsuggestion", emailSuggestion);
  console.log("text", text);
  return (
    <div className='main-wrapper'>
      {/* <Aside
        reviewname={'Add Reviews'}
        reviewtitle={'Reviews'}
      /> */}
      <AsidebarNew />
      <div className='content-wrapper '>
        <TopBar />
        <div className='container page--content'>
          <div className='page--section' style={{zIndex:1}}>
            <div className='row' style={{ marginTop: "20px" }}>
              <div className='col-sm-6 '>
                <h2 className='page--heading'>Review Listing</h2>
              </div>
              <div className='col-sm-6 col-xs-12 text--align--right '>
                {/* <a href="addreview" className="tem--add--btn"></a> */}
                <Link to='/addreview' className='tem--add--btn'>
                  <IoIosAdd /> Add New
                </Link>
              </div>
            </div>
          </div>
         <DashboardReview/>

        </div>
      </div>
    </div>
  );
}
{
  /* <ButtonComponent text={"Invite User"} handleSubmit={handleSubmitInvitation} /> */
}
export default Review;
